import { useState } from 'react';

function UserToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('fleetnexis_token');
    const userToken = tokenString;
    return userToken;
  };
  const [token, setToken] = useState(getToken());
  const saveToken = (userToken) => {
    localStorage.setItem('fleetnexis_token', userToken);
    setToken(userToken.token);
  };
  return {
    setToken: saveToken,
    token,
  };
}

export default UserToken;
